import I18n from "i18n-js";
import React from "react";

export default class DeviceConnectionStatus extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { wifi_level, connected } = this.props;
    if (wifi_level) {
      return (
        <div
          style={{
            display: "inline-block",
            width: "24px",
            cursor: "pointer",
            position: "relative",
            top: "-2px",
            margin: "0",
          }}
          data-placement="top"
          title={I18n.t("wifi_status", { status: wifi_level + "%" })}
        >
          {this.renderWifiIcon(wifi_level)}
        </div>
      );
    } else if (connected === false || connected === true) {
      return (
        <div
          style={{
            display: "inline-block",
            width: "24px",
            cursor: "pointer",
            position: "relative",
            top: "-2px",
            margin: "0",
          }}
          data-placement="top"
          title={connected ? I18n.t("online") : I18n.t("offline")}
        >
          {this.renderConnectedIcon(connected)}
        </div>
      );
    } else {
      return null;
    }
  }

  renderConnectedIcon(connected) {
    if (connected) {
      return (
        <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
          <path
            fill="rgb(0, 200, 88)"
            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"
          />
        </svg>
      );
    } else {
      return (
        <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
          <path
            fill="red"
            d="M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
          />
        </svg>
      );
    }
  }

  renderWifiIcon(strength) {
    return (
      <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
        <path
          fill={strength > 10 ? "rgb(0, 200, 88)" : "red"}
          d={this.pathDefinition(strength)}
        />
      </svg>
    );
  }

  pathDefinition(strength) {
    if (strength > 96) {
      return "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3Z";
    } else if (strength > 75) {
      return "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L18.77,9.88C17.26,9 14.88,8 12,8C9,8 6.68,9 5.21,9.84L3.27,7.44C5.91,5.85 8.93,5 12,5Z";
    } else if (strength > 50) {
      return "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L17.5,11.43C16.26,10.74 14.37,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.93,5 12,5Z";
    } else if (strength > 10) {
      return "M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L15.61,13.81C14.5,13.28 13.25,13 12,13C10.75,13 9.5,13.28 8.39,13.8L3.27,7.44C5.91,5.85 8.93,5 12,5Z";
    } else {
      return "M12 3C7.8 3 3.7 4.4 .4 7C4.3 11.8 8.2 16.7 12 21.5C14.3 18.6 16.7 15.7 19 12.8V9.6L12 18.3L3.3 7.4C5.9 5.8 8.9 5 12 5C15.1 5 18.1 5.9 20.7 7.4L20.3 8H22.9C23.2 7.7 23.4 7.3 23.7 7C20.3 4.4 16.2 3 12 3M21 10V16H23V10M21 18V20H23V18";
    }
  }
}
